const BASE_API_URL = 'https://quizapi.codenil.online';

export default BASE_API_URL;